<template>
    <div class="scenes-column-wrapper">
        <p class="scenes-name">{{ firstScenes }}</p>
        <p class="scenes-name">
            <span v-show="showIcon">{{ scenesChart }}</span>
            {{ secondScenes }}
        </p>
    </div>
</template>

<script>
export default {
    name: "ScenesColumn",
    props: ["data", "row"],
    data() {
        return {
            scenesChart: ">",
            firstScenes: this.getScenesTxt(this.data[0]),
            secondScenes: this.getScenesTxt(this.data[1])
        };
    },
    computed: {
        showIcon() {
            let [firstScens, secondScens] = this.data;
            if (firstScens && secondScens) {
                return true;
            } else {
                return false;
            }
        }
    },
    methods: {
        getScenesTxt(data) {
            if (data) {
                return data.split("(")[0];
            } else {
                return "";
            }
        }
    }
};
</script>
